export default function kebabToPascal(str) {
  return str
    .replace(/\s/g, '')
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
}
